<template>
  <div>
    <div>
      <Button type="primary" icon="ios-search" @click="showSearch">搜索</Button>
      <Button style="margin-left: 20px" type="primary" icon="md-cloud-upload" @click="dialogVisible = true">导出
      </Button>
    </div>

    <Modal title="Title" v-model="dialogVisible" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <span>导出</span>
      </p>
      <div style="padding-left: 20px;">
        <CheckboxGroup v-model="dialogConditions" class="check_group">
          <div>
            <Checkbox label="id">
              <span>消息编号</span>
            </Checkbox>
            <Input v-model="dialogCondition.id" placeholder=""/>
          </div>
          <div>
            <Checkbox label="num">
              <span>设备编号</span>
            </Checkbox>
            <Input v-model="dialogCondition.num" placeholder=""/>
          </div>
          <div>
            <Checkbox v-model="dialogCondition.typeCheck" label="subType">
              <span>类型</span>
            </Checkbox>
            <Select v-model="dialogCondition.subType" placeholder="">
              <Option v-for="(item,index) in boxProfile.upload" :value="index">{{ item.cn }}</Option>
            </Select>
          </div>
          <div v-if="dialogCondition.typeCheck && dialogCondition.subType === 'calibrateUpload'">
            <Checkbox v-model="dialogCondition.deviceStatusCheck" label="deviceStatus">
              <span>标定状态</span>
            </Checkbox>
            <Select v-model="dialogCondition.deviceStatus" placeholder="">
              <Option value="null">全部</Option>
              <Option value="1">正常</Option>
              <Option value="0">异常</Option>
            </Select>
          </div>
          <div>
            <Checkbox label="happenTime">
              <span>时间范围</span>
            </Checkbox>
            <Tooltip transfer placement="top" :disabled="dialogCondition.happenTimeRange[0] == ''">
              <div slot="content">
                <span>{{ dateFtt('yyyy-MM-dd hh:mm:ss', dialogCondition.happenTimeRange[0]) }}</span>
                <br/>
                <span style="margin-left:50%">~</span>
                <br/>
                <span>{{ dateFtt('yyyy-MM-dd hh:mm:ss', dialogCondition.happenTimeRange[1]) }}</span>
              </div>
              <DatePicker v-model="dialogCondition.happenTimeRange" type="daterange" split-panels
                          placeholder=""></DatePicker>
            </Tooltip>
          </div>
          <div>
            <Checkbox label="pageSize">
              <span>导出条数</span>
            </Checkbox>
            <InputNumber :precision="0" v-model="dialogCondition.pageSize" placeholder="默认仅导出50条"/>
          </div>
        </CheckboxGroup>
      </div>
      <div slot="footer">
        <Button type="info" size="large" long @click="exportExcel">立即导出</Button>
      </div>
    </Modal>

    <Modal title="Title" v-model="searchModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <span>搜索</span>
      </p>
      <div style="padding-left: 20px;">
        <CheckboxGroup v-model="selectedConditions" class="check_group">
          <div>
            <Checkbox label="id">
              <span>消息编号</span>
            </Checkbox>
            <Input v-model="condition.id" placeholder=""/>
          </div>
          <div>
            <Checkbox label="num">
              <span>设备编号</span>
            </Checkbox>
            <Input v-model="condition.num" placeholder=""/>
          </div>
          <div>
            <Checkbox v-model="typeCheck" label="subType">
              <span>类型</span>
            </Checkbox>
            <Select v-model="condition.subType" placeholder="">
              <Option v-for="(item,index) in boxProfile.upload" :value="index">{{ item.cn }}</Option>
            </Select>
          </div>
          <div v-if="typeCheck && condition.subType === 'calibrateUpload'">
            <Checkbox v-model="deviceStatusCheck" label="deviceStatus">
              <span>标定状态</span>
            </Checkbox>
            <Select v-model="deviceStatus" placeholder="">
              <Option value="null">全部</Option>
              <Option value="1">正常</Option>
              <Option value="0">异常</Option>
            </Select>
          </div>
          <div>
            <Checkbox label="happenTime">
              <span>时间范围</span>
            </Checkbox>
            <Tooltip transfer placement="top" :disabled="condition.happenTimeRange[0] == ''">
              <div slot="content">
                <span>{{ dateFtt('yyyy-MM-dd hh:mm:ss', condition.happenTimeRange[0]) }}</span>
                <br/>
                <span style="margin-left:50%">~</span>
                <br/>
                <span>{{ dateFtt('yyyy-MM-dd hh:mm:ss', condition.happenTimeRange[1]) }}</span>
              </div>
              <DatePicker v-model="condition.happenTimeRange" type="daterange" split-panels
                          placeholder=""></DatePicker>
            </Tooltip>
          </div>
        </CheckboxGroup>
      </div>
      <div slot="footer">
        <Button type="info" size="large" long @click="searchByCondition">立即搜索</Button>
      </div>
    </Modal>

    <br/>
    <Table size="large" border stripe :loading="loading" :columns="columns1" :data="data1">
      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" shape="circle" icon="ios-apps" @click="showData(row, index)"></Button>
      </template>
    </Table>
    <br/>

    <Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40, 50]"
          show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize"/>
  </div>
</template>

<script>
import {
  constants
} from "crypto";
import * as XLSX from "xlsx";
import {saveAs} from 'file-saver';

export default {
  name: "meter_alarm_upload_info",
  data() {
    let that = this;
    return {
      boxProfile: {},
      data1: [],
      typeCheck: false,
      dialogVisible: false,
      dialogConditions: [],
      dialogCondition: {
        id: '',
        mac: '',
        subType: '',
        typeCheck: false,
        deviceStatusCheck: false,
        deviceStatus: 'null',
        happenTimeRange: [],
        pageSize: ''
      },
      deviceStatusCheck: false,
      deviceStatus: 'null',
      loading: true,
      showDrawer: false,
      selectDataHtml: '',
      selectData: {},
      searchModal: false,
      currentPage: 1,
      pageSize: 30,
      totalRows: 0,
      selectedConditions: [],
      condition: {
        id: '',
        mac: '',
        subType: '',
        happenTimeRange: [],
      },
      requestBody: {},
      columns1: [
        {
          title: "姓名",
          key: "name",
          align: "center",
          width: 100,
        },
        {
          title: "电话",
          key: "telephone",
          align: "center",
          width: 200,
        },
        {
          title: "地址",
          key: "address",
          align: "center",
          width: 300,
        },
        {
          title: "消息编号",
          key: "id",
          align: "center",
          width: 200
        },
        {
          title: "设备编号",
          key: "num",
          align: "center",
          width: 200
        },
        {
          title: "类型",
          key: "subType",
          align: "center",
          width: 230,
          render: function (h, params) {
            let subType = that.boxProfile[params.row.mainType][params.row.subType];
            return h(
                "div",
                subType == null ? '未匹配：' + params.row.subType : subType.cn
            );
          }
        },
        {
          title: "上传时间",
          align: "center",
          width: 200,
          render: function (h, params) {
            try {
              if (params.row.happenTime != undefined) {
                let timeStr = global.dateFtt(
                    "yyyy-MM-dd hh:mm:ss",
                    new Date(params.row.happenTime)
                );
                return h("div", timeStr == "" ? "设备未校时" : timeStr);
              } else {
                return h(
                    "div",
                    global.dateFtt(
                        "yyyy-MM-dd hh:mm:ss",
                        new Date(params.row.receiveTime)
                    )
                );
              }
            } catch (err) {
              return h("div", "JSON格式错误");
            }
          }
        },
        {
          title: "标定状态",
          key: "deviceStatus",
          align: "center",
          width: 100,
          render: function (h, params) {
            return h(
                "div",
                {
                  style: {
                    color: params.row.deviceStatus === '' ? '' : params.row.deviceStatus ? '#2d8cf0' : '#ed4014'
                  }
                },
                params.row.deviceStatus === '' ? '' : params.row.deviceStatus ? '正常' : '异常'
            );
          }
        },
        {
          title: "详细信息",
          slot: "action",
          align: "center",
          width: 100
        }
      ],
    };
  },
  created() {
    this.getBoxProfile()
    this.getMessage()
  },
  mounted() {

  },
  methods: {
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, new Date(date));
    },
    getBoxProfile() {
      let that = this;
      that.loading = true;
      $.ajax({
        url: "/api/alarm/admin/message/getNBProfile",
        async: false,
        success: function (result) {
          if (!result.success) {
            that.$Notice.error({
              title: "异常",
              desc: result.msg
            });
            return;
          }

          that.boxProfile = result.data;
        },
        error: function () {
          that.$Notice.error({
            title: "异常",
            desc: "网络异常"
          });
        },
        complete: function () {
          that.loading = false;
        }
      });
    },
    // 显示条件检索页面
    showSearch() {
      this.searchModal = true;
    },
    searchByCondition() {
      this.requestBody = {};
      for (let i in this.selectedConditions) {
        let selectedCondition = this.selectedConditions[i]
        switch (selectedCondition) {
          case 'happenTime':
            let happenTimeBegin = this.condition.happenTimeRange[0];
            if (happenTimeBegin != '') {
              this.requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
                  happenTimeBegin);
            }
            let happenTimeEnd = this.condition.happenTimeRange[1];
            if (happenTimeEnd != '') {
              this.requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
            }
            break;
          default:
            let value = this.condition[selectedCondition];
            if (value == null || value == '') {
              break;
            }

            this.requestBody[selectedCondition] = value;
            break;
        }
      }

      this.loading = true;
      this.searchModal = false;
      this.currentPage = 1;
      this.getMessage();
    },
    getMessage() {
      let that = this;
      if (localStorage.getItem("isAdmin") != "true") {
        that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
      }

      if (that.typeCheck && that.condition.subType === 'calibrateUpload' && that.deviceStatusCheck && that.deviceStatus !== 'null') {
        that.requestBody.deviceStatus = that.deviceStatus === '1'
      }
      that.requestBody["type"] = 1;
      $.ajax({
        url: "/api/alarm/admin/message/getNBUploadList?currentPage=" +
            that.currentPage +
            "&pageSize=" +
            that.pageSize,
        type: "post",
        data: that.requestBody,
        success: function (result) {
          if (!result.success) {
            that.$Notice.error({
              title: "异常",
              desc: result.msg
            });
            return;
          }

          result.data.list.map(item => {
            const parse = JSON.parse(item.original);
            if (parse.subType === "calibrateUpload") {
              item['deviceStatus'] = parse.data.adThresholdH - parse.data.adThresholdL > 80 && parse.data.adMutationThs > 0
            } else {
              item['deviceStatus'] = ''
            }
          })

          that.data1 = result.data.list;
          that.totalRows = result.data.totalRows;
          that.loading = false;
        },
        error: function (textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "网络不通"
          });
        }
      });
    },
    exportExcel() {
      let that = this;
      let requestBody = {};
      for (let i in this.dialogConditions) {
        let selectedCondition = this.dialogConditions[i]
        switch (selectedCondition) {
          case 'happenTime':
            let happenTimeBegin = this.dialogCondition.happenTimeRange[0];
            if (happenTimeBegin !== '') {
              requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
                  happenTimeBegin);
            }
            let happenTimeEnd = this.dialogCondition.happenTimeRange[1];
            if (happenTimeEnd !== '') {
              requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
            }
            break;
          default:
            let value = this.dialogCondition[selectedCondition];
            if (value == null || value === '') {
              break;
            }

            requestBody[selectedCondition] = value;
            break;
        }
      }

      if (this.dialogCondition.typeCheck && this.dialogCondition.subType === 'calibrateUpload' && this.dialogCondition.deviceStatusCheck && this.dialogCondition.deviceStatus !== 'null') {
        requestBody.deviceStatus = Boolean(this.dialogCondition.deviceStatus === '1')
      }
      requestBody["type"] = 1;

      if (!requestBody.pageSize) {
        requestBody.pageSize = 50
      }
      if (!requestBody.subType) {
        that.$Notice.error({
          title: "异常",
          desc: "请选择类型！"
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '正在导出，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      $.ajax({
        url: "/api/alarm/admin/message/getNBUploadList?currentPage=" +
            1 +
            "&pageSize=" +
            requestBody.pageSize,
        type: "post",
        data: requestBody,
        success: function (result) {
          if (!result.success) {
            that.$Notice.error({
              title: "异常",
              desc: result.msg
            });
            loading.close();
            return;
          }
          loading.close();
          const data = [
            [
              "姓名",
              "电话",
              "地址",
              "消息编号",
              "设备编号",
              "类型",
              "上传时间"
            ],
          ];
          if (requestBody.subType === "calibrateUpload") {
            data[0].push("标定状态")
            data[0].push("报警ad高阈值")
            data[0].push("报警ad低阈值")
            data[0].push("突变阈值")
          } else {
            Object.keys(that.boxProfile["upload"][requestBody.subType]["params"]).forEach(key => {
              data[0].push(that.boxProfile["upload"][requestBody.subType]["params"][key].cn)
            })
          }

          result.data.list.forEach(item => {
            const parse = JSON.parse(item.original);
            let subType = that.boxProfile[item.mainType][item.subType];
            let timeStr;
            if (item.happenTime !== undefined) {
              timeStr = global.dateFtt(
                  "yyyy-MM-dd hh:mm:ss",
                  new Date(item.happenTime)
              );
            } else {
              timeStr = global.dateFtt(
                  "yyyy-MM-dd hh:mm:ss",
                  new Date(item.receiveTime)
              )
            }
            if (parse.subType === "calibrateUpload") {
              item['deviceStatus'] = (parse.data.adThresholdH - parse.data.adThresholdL > 80 && parse.data.adMutationThs > 0) ? '正常' : '异常'
              item['adThresholdH'] = parse.data.adThresholdH
              item['adThresholdL'] = parse.data.adThresholdL
              item['adMutationThs'] = parse.data.adMutationThs
            } else {
              Object.keys(that.boxProfile["upload"][requestBody.subType]["params"]).forEach(key => {
                item[key] = parse.data[key]
              })
            }
            const list = [
              item.name == null ? '' : item.name,
              item.telephone == null ? '' : item.telephone,
              item.address == null ? '' : item.address,
              item.id == null ? '' : item.id,
              item.num == null ? '' : item.num,
              subType == null ? '未匹配：' + item.subType : subType.cn,
              timeStr
            ]
            if (requestBody.subType === "calibrateUpload") {
              list.push(item['deviceStatus'])
              list.push(item['adThresholdH'])
              list.push(item['adThresholdL'])
              list.push(item['adMutationThs'])
            } else {
              Object.keys(that.boxProfile["upload"][requestBody.subType]["params"]).forEach(key => {
                list.push(item[key])
              })
            }
            data.push(list)
          })
          // 将数据转换为工作表
          const worksheet = XLSX.utils.aoa_to_sheet(data);

          // 创建工作簿并添加工作表
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

          // 生成Excel文件
          const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});

          // 使用blob和FileReader创建一个URL然后下载
          const dataBlob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
          saveAs(dataBlob, 'NB报警器上传记录.xlsx');
          loading.close();
        },
        error: function (textStatus) {
          loading.close();
          that.$Notice.error({
            title: "异常",
            desc: "网络不通"
          });
        }
      });
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.request();
    },
    changePage(index) {
      this.currentPage = index;
      this.loading = true;
      this.getMessage();
    },
    convertData(data, type, enums) {
      let result = data;
      if (type == "Time") {
        result = global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(data * 1000));
      } else if (type == "Enum") {
        result = enums[data] == null ? data : enums[data];
      }
      return result;
    },
    showData(row, index) {
      // 遍历数据集拼接HTML
      let html = "";
      let that = this;
      let mainType = row.mainType;
      let subType = row.subType;

      try {
        html =
            "<table style='border:1px solid #C0C0C0; text-align: center;width: 100%; table-layout:fixed;'>";
        let amount = 0;
        let data = JSON.parse(row.content);
        let se = '';
        Object.keys(data).forEach(function (key) {
          if (that.boxProfile[mainType] == null ||
              that.boxProfile[mainType][subType] == null ||
              that.boxProfile[mainType][subType]["params"][key] == null) {
            return;
            // throw new Error("JSON格式错误");
          }

          if (amount % 2 == 0) {
            html += "<tr >";
          }
          let keyObj = that.boxProfile[mainType][subType]["params"][key];
          console.log(keyObj);
          html += "<td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
              keyObj.cn + "</td>";
          //关阀上传解析JSON格式与其他上传格式不同所以单独判断
          if (keyObj.cn == '关阀原因' && keyObj.type !== 'Enum') {
            if (that.convertData(data[key], keyObj.type, keyObj.enum) == 'platform') {
              se = '平台下发';
            } else if (that.convertData(data[key], keyObj.type, keyObj.enum) == 'overDensity') {
              se = '浓度超限报警';
            } else {
              se = '按键关阀';
            }
            html += "<td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
                se + "</td>";
          } else {
            html += "<td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
                that.convertData(data[key], keyObj.type, keyObj.enum) + " " + (keyObj.unit == null ?
                    "" : keyObj.unit) + "</td>";
          }
          if (amount % 2 == 1) {
            html += "</tr>";
          }
          amount++;
        });
        html += "</table>";
        that.selectDataHtml = html;
        that.selectData = data;
      } catch (err) {
        console.log(err);
        that.selectDataHtml = "<div>JSON格式错误</div>";
        that.selectData = row.content;
        html = that.selectDataHtml;
      }

      that.$Notice.open({
        title: "存储编号:" + row.id + "\t设备编号:" + row.num,
        render: h => {
          return h("div", {
            on: {},
            style: {
              height: "100%",
              width: "100%"
            },
            domProps: {
              innerHTML: html
            }
          });
        },
        duration: 20
      });
    }
  },
};
</script>

<style>
.check_group > div {
  margin-bottom: 10px;
}

.check_group > div > label {
  width: 100px;
}

.check_group > div > div {
  width: 200px;
}

.ivu-date-picker {
  width: 100%;
}
</style>
